// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import {
    chain,
    PopulateApiParameter,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/Quotes/Handlers/LoadQuote";
import { getQuote } from "@pace/App/Services/QuoteService";

export const XPopulateApiParameter: typeof PopulateApiParameter = props => {
    // XNG-Change: add getRealTimeCall for the api
    const state = props.getState();
    const page = getCurrentPage(state);
    props.apiParameter = {
        ...props.apiParameter,
        ...(page.type === "RfqConfirmationPage" ? {} : { getRealTimeCall: true }),
    };
};

export const XRequestDataFromApi: typeof RequestDataFromApi = async props => {
    try {
        // XNG-Change: using new getQuote service
        props.apiResult = await getQuote(props.apiParameter);
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 404)) {
            props.dispatch({
                type: "Data/Quotes/FailedToLoadQuote",
                quoteId: props.parameter.quoteId,
                status: 404,
            });
            return false;
        }
        throw error;
    }
};

addToChainAfter(chain, PopulateApiParameter, XPopulateApiParameter);
replaceInChain(chain, RequestDataFromApi, XRequestDataFromApi);
